import { CEP_RISK_PROFILE } from 'constants/constants';
import {
    useCallback, useEffect, useReducer,
} from 'react';

type State = Record<string, unknown>;
type Action = { type: 'setData'; payload: State };

const initialState: State = {
    clientName: '',
    clientAge: undefined,
    risk: '',
};

const reducer = (state: State = initialState, action: Action): State => {
    switch (action.type) {
        case 'setData':
            return { ...state, ...action.payload };
        default:
            return state;
    }
};

export const useRiskProfile = () => {
    const initialCachedState = JSON.parse(sessionStorage.getItem(CEP_RISK_PROFILE) || 'null') ?? initialState;
    const [state, dispatch] = useReducer(reducer, initialCachedState);
    const setData = useCallback((lData: State) => {
        dispatch({ type: 'setData', payload: lData });
    }, []);

    useEffect(() => {
        sessionStorage.setItem(CEP_RISK_PROFILE, JSON.stringify(state));
    }, [state]);

    return {
        data: state,
        setData,
    };
};
